import { color } from "@material-ui/system"
import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        title: {
            minHeight: '53px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
        },
        subtitle: {
            fontWeight: '500',
            color: colors.color4
        },
        containerImpor: {
            display: 'flex',
            justifyContent: 'end',
            padding: '16px 0px'
        },
        mainContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
        buttonsContainer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .back': {
                width: '80px',
                height: '36px',
            },
            '& .next': {
                borderRadius: '4px',
            },
        },
        body: {
            flex: 1,
        }
    }
}

export { useStyles }
